var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"instruction"},[_c('p',{staticClass:"instruction--number"},[_vm._v(_vm._s(_vm.number))]),_vm._v(" "),_c('p',{staticClass:"instruction--text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }